import { useEffect, useState } from 'react'
import { EVENT_TYPE_SCREENING, EVENT_TYPE_THERAPY_SESSION } from 'src/consumer/constants'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import RosterComponent from 'src/supportPortal/components/common/roster/RosterComponent'
import { buildNewRosterRequest } from 'src/supportPortal/components/common/roster/utils'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import RosterForm from 'src/supportPortal/views/roster/component/RosterForm'
import ClinicRosterItemViewer from 'src/supportPortal/views/roster/component/viewers/ClinicRosterItemViewer'

export default function RosterPage() {
  const [allChamberRooms, setAllChamberRooms] = useState()
  const [selectedChamberRoom, setSelectedChamberRoom] = useState()
  const [loading, setLoading] = useState(false)

  async function getAllChamberRooms() {
    const { getChamberRoomsWithDetails } = await import('src/supportPortal/services/rosterManagementService')
    const resp = await getChamberRoomsWithDetails({
      preferredEventTypes: [EVENT_TYPE_THERAPY_SESSION, EVENT_TYPE_SCREENING],
      rostered: true,
      includeAssociatedMentors: true, // Include mentors filtered by RosterSchedule.eventTypes
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const roomData = getDataMapFromCommonResponse(resp)?.['chamber-room']
        setAllChamberRooms(roomData)
        setSelectedChamberRoom(roomData?.[0])
      }
    }
  }

  async function setup() {
    setLoading(true)
    await Promise.all([getAllChamberRooms()])
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [])

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading={
          <span>
            {selectedChamberRoom ? (
              <>
                <span className="fw-bold">{selectedChamberRoom.clinicBrandName}</span> |{' '}
                <span>{selectedChamberRoom.clinicLocationName}</span> |{' '}
                <span className="fw-light">{selectedChamberRoom.title}</span>
              </>
            ) : (
              'Clinic'
            )}{' '}
            Roster
          </span>
        }
      />
      <RosterComponent
        loadingData={loading}
        getOptionLabel={(optn) =>
          `${optn?.clinicBrandName} ${optn?.clinicLocationName} ${optn?.title}`
        }
        getOptionValue={(optn) => optn?.id}
        rosterListFetchApiSignature="/api/secure/cc/support/roster/chamber-room"
        itemOptions={allChamberRooms}
        getSidebarLegendItems={(room) => room?.associatedMentors}
        getSidebarLegendLabel={(leg) => leg?.name || leg?.title}
        getSidebarLegendValue={(leg) => leg?.id}
        legendTitle="Mentors"
        rosterApiIdParamKey="chamberRoomId"
        sidebarLegends={selectedChamberRoom?.associatedMentors}
        getSidebarItemReferenceFromRosterItem={(rosterItem) => rosterItem?.mentorId}
        getSelectedItemSchedules={(selectedRoom) => selectedRoom?.clinicLocationSchedule || []}
        selectedItem={selectedChamberRoom}
        setSelectedItem={setSelectedChamberRoom}
        RosterFormComponent={RosterForm}
        RosterSlotViewComponent={ClinicRosterItemViewer}
        rosterRequestBuilder={({
          startTimeString,
          endTimeString,
          currentDateString,
          selectedItem,
        }) => {
          return buildNewRosterRequest(
            selectedItem?.clinicBrandId,
            selectedItem?.clinicLocationId,
            selectedItem?.id,
            null,
            currentDateString,
            startTimeString,
            endTimeString,
          )
        }}
      />
    </div>
  )
}
